import * as React from "react";
const SvgSlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.25 3.5L6 15.5", stroke: "#D4D4D4", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgSlash;
